import {
  decoded,
} from '../../utils';
import Config from "../../utils/Config";
import { apiRequest } from './apiRequest';

export const createApiAction = ({
    url,
    method = 'post',
    formData,
    type,
    isPost = false,
    useDecoded = false,
    storeToken = false,
    customHeaders = {},
    transformOverride,
  }) => {
    return apiRequest({
      url,
      method,
      body: isPost ? formData : undefined,
      headers: isPost
        ? { ...Config.getHeaders(), ...customHeaders }
        : { "X-Custom-Data": formData, ...customHeaders },
  
      successType: type,
      errorType: 'ERROR_MESSAGE',
      successMessage: url.replace('/', ''),
      loadingType: 'LOADING',
  
      transformResponse: transformOverride
        ? transformOverride
        : (data, dispatch) => {
            const res = decoded(data);
  
            // Optionally store token
            if (storeToken && res?.token) {
              localStorage.setItem('Authorization', res.token);
            }
  
            // Handle post error message
            if (isPost) {
              dispatch({
                type: 'ERROR_MESSAGE',
                payload: res?.message === 'SUCCESS' ? '' : res?.message,
              });
            }
  
            // For GET, just return decoded
            return isPost ? url.replace('/', '') : res;
          },
    });
  };
  